// extracted by mini-css-extract-plugin
export var change = "_3m-1";
export var changeList = "_3m-0";
export var changePath = "_3m-2";
export var diffArrow = "_3m-5";
export var diffRow = "_3m-3";
export var diffValue = "_3m-4";
export var error = "_3m-8";
export var notice = "_3m-9";
export var result = "_3m-6";
export var success = "_3m-7";